import styled, {AnyStyledComponent} from 'styled-components';
import { GridAlignTypes } from './grid.types';

interface StyledGridProps {
  verticalGutter: number;
  horizontalGutter: number;
  hasBorderGutter: boolean;
  justifyContent: GridAlignTypes;
}

// Provide a styled wrapper for the grid items, complete with justifying action
export const GridWrapper: AnyStyledComponent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${({ justifyContent }: StyledGridProps) => justifyContent};

  ${({ hasBorderGutter, verticalGutter, horizontalGutter }: StyledGridProps) => {

    if (!hasBorderGutter) {
      return `margin: -${verticalGutter / 2}px -${horizontalGutter / 2}px;`;
    }

    return `padding: ${verticalGutter / 2}px ${horizontalGutter / 2}px;`;

  }};
`;
